import React from 'react';

export const EmployeeId = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const EmployeeName = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const Location = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const Designation = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const RulesApplied = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const CTCWage = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const Basic = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const HRA = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const ConveyanceAllowance = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const SpecialAllowance = ({ value }) => {
  return <span>{value || ''}</span>;
};

export const Action = ({ value }) => {
  return <span>{value || ''}</span>;
};
